import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { TableModule } from 'src/app/table/table.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { TenantScheduleDetailsComponent } from './tenant-schedule-details.component';
import { TenantScheduleDetailsRoutingModule } from './tenant-schedule-details-routing.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { MatDividerModule } from '@angular/material/divider';
import { CommonTableModule } from 'src/app/components/table/table.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
@NgModule({
  declarations: [
    TenantScheduleDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    TenantScheduleDetailsRoutingModule,
    BreadcrumbModule,
    TableModule,
    PaginatorModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    CommonTableModule,
    SearchFilterModule,
    NgxSkeletonLoaderModule
  ],
  exports: [TenantScheduleDetailsComponent]
})
export class TenantScheduleDetailsModule { }